import { type HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

/**
 * Card variant definitions.
 *
 * ### Variants
 * | variant   | description                                   |
 * |-----------|-----------------------------------------------|
 * | `default` | White card with border, rounded corners, shadow |
 * | `flat`    | White card with shadow but no border           |
 */
const cardVariants = cva('bg-surface overflow-hidden', {
  variants: {
    variant: {
      default: 'border border-border rounded-card',
      flat: 'rounded-card',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export type CardProps = HTMLAttributes<HTMLDivElement> & VariantProps<typeof cardVariants>;

export { cardVariants };
